export default "__VITE_ASSET__BJm$32Zw__"